<template>
  <div class="backtest-history">
    <div class="history-header">
      <h4>Test History</h4>
      <span v-if="loading" class="loading-indicator">Loading...</span>
    </div>

    <div v-if="loading && tests.length === 0" class="no-tests">
      <p>Loading tests...</p>
    </div>

    <div v-else-if="tests.length === 0" class="no-tests">
      <p>No tests yet</p>
    </div>

    <div v-else class="test-list">
      <div
        v-for="test in displayedTests"
        :key="test.Id"
        :class="['test-item', { active: test.Id === selectedTestId }]"
        @click="$emit('select-test', test.Id)"
      >
        <div class="test-header">
          <div class="test-title">
            <span class="test-name">Test #{{ test.Id }}</span>
          </div>
          <div class="test-right">
            <span v-if="test.Status === 'Processing'" class="test-progress">
              <span class="progress-text">{{ test.Progress }}%</span>
            </span>
            <span
              :class="['test-status', `status-${test.Status.toLowerCase()}`]"
            >
              {{ test.Status }}
            </span>
          </div>
        </div>

        <div class="test-meta">
          <div class="test-header-row">
            <div class="test-date">
              {{ formatDate(test.CreatedAt) }}
            </div>
            <div v-if="test.JobType" class="test-algorithm-type">
              {{ test.JobType }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <button v-if="hasMore" class="btn btn-link show-more-btn" @click="loadMore">
      Show more
    </button>
  </div>
</template>

<script>
export default {
  name: 'BackTestHistory',
  props: {
    tests: {
      type: Array,
      default: () => []
    },
    selectedTestId: {
      type: [String, Number],
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    totalCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {}
  },
  computed: {
    displayedTests() {
      return this.tests
    },
    hasMore() {
      return this.tests.length < this.totalCount
    }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    },
    loadMore() {
      this.$emit('load-more')
    }
  }
}
</script>

<style scoped lang="scss">
.history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;

  h4 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 0;
  }

  .loading-indicator {
    font-size: 12px;
    color: #007bff;
    font-style: italic;
  }
}
.backtest-history {
  margin-top: 30px;

  h4 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 15px;
  }

  .no-tests {
    text-align: center;
    color: #999;
    padding: 20px;
    font-size: 14px;
  }

  .test-list {
    .test-item {
      padding: 12px;
      margin-bottom: 7px;
      border: 1px solid #ddd;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.2s;
      background-color: #fff;

      &:hover {
        border-color: #007bff;
        background-color: #f8f9fa;
      }

      &.active {
        border-color: #007bff;
        background-color: #e7f3ff;
      }

      .test-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;

        .test-title {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .test-name {
          font-weight: 600;
          font-size: 14px;
        }

        .test-right {
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .test-progress {
          font-size: 12px;
          color: #ffc107;
          font-weight: 600;

          .progress-text {
            font-size: 12px;
          }
        }

        .test-status {
          font-size: 12px;
          padding: 2px 8px;
          border-radius: 3px;
          font-weight: 500;

          &.status-completed {
            background-color: #d4edda;
            color: #155724;
          }

          &.status-failed {
            background-color: #f8d7da;
            color: #721c24;
          }

          &.status-processing {
            background-color: #fff3cd;
            color: #856404;
          }

          &.status-queued {
            background-color: #d1ecf1;
            color: #0c5460;
          }
        }
      }

      .test-meta {
        .test-header-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .test-date {
          font-size: 11px;
          color: #666;
        }

        .test-algorithm-type {
          font-size: 11px;
          color: #666;
        }
      }
    }
  }

  .show-more-btn {
    width: 100%;
    font-size: 13px;
  }
}
</style>
